import KitSerializer, { serializePriceMode } from "../rna-fish/KitSerializer";
import RnaCishKitSerializer from "../rna-cish/KitSerializer";
var ManualProAdminKitSerializer = /** @class */ (function () {
    function ManualProAdminKitSerializer() {
        var _this = this;
        this.setProbeSetState = function (state) {
            _this.probeSetState = state;
        };
        this.setAmplifier = function (state) {
            _this.amplifierState = state;
        };
        this.setProBuffers = function (state) {
            _this.proBuffersState = state;
        };
        this.setManualBuffers = function (state) {
            _this.manualBuffersState = state;
        };
        this.setChromogen = function (state) {
            _this.chromogenState = state;
        };
        this.serializeKit = function (comment, sampleType) {
            var buffers = [];
            var buffersPrices = [];
            var probeSetComponent = null;
            var probeSetPriceMode = null;
            if (_this.probeSetState) {
                var scalePmol = _this.probeSetState.scale.valuePmol;
                probeSetComponent = {
                    _type: 'manual',
                    probeSet: KitSerializer
                        .serializeProbeSet(_this.probeSetState.organism, _this.probeSetState.target, _this.probeSetState.hcrAmplifier, _this.probeSetState.probeLotNumber),
                    scalePmol: scalePmol,
                    index: 1
                };
                probeSetPriceMode = serializePriceModeWithIndex(1, _this.probeSetState.customPrice);
            }
            var amplifierComponent = null;
            var amplifierPriceMode = null;
            if (_this.amplifierState) {
                amplifierComponent = RnaCishKitSerializer.serializeAmplifier(_this.amplifierState);
                amplifierPriceMode = serializePriceModeWithIndex(1, _this.amplifierState.customPrice);
            }
            var proBuffersComponent = null;
            var proBuffersPriceMode = null;
            if (_this.proBuffersState) {
                //TODO fix this pass through of protocol type
                proBuffersComponent = RnaCishKitSerializer.serializeBuffers(_this.proBuffersState, { id: 'MANUAL', label: 'Manual', alias: 'MANUAL' });
                proBuffersPriceMode = serializePriceModeWithIndex(2, _this.proBuffersState.customPrice);
                buffers.push(proBuffersComponent);
                buffersPrices.push(proBuffersPriceMode);
            }
            var chromogenComponent = null;
            var chromogenPriceMode = null;
            if (_this.chromogenState) {
                chromogenComponent = RnaCishKitSerializer.serializeChromogenComponent(_this.chromogenState);
                chromogenPriceMode = serializePriceModeWithIndex(1, _this.chromogenState.customPrice);
            }
            var manualBuffersComponent = null;
            var manualBuffersPriceMode = null;
            if (_this.manualBuffersState) {
                manualBuffersComponent = KitSerializer.serializeBuffers(_this.manualBuffersState);
                manualBuffersPriceMode = serializePriceModeWithIndex(1, _this.manualBuffersState.customPrice);
                buffers.push(manualBuffersComponent);
                buffersPrices.push(manualBuffersPriceMode);
            }
            return {
                '_type': 'bundle-of-kits',
                kit: {
                    sampleTypeId: sampleType.id,
                    protocolType: 'MANUAL',
                    kits: [
                        {
                            channel: 1,
                            config: 'Manual Pro',
                            probeSetComponents: probeSetComponent ? [probeSetComponent] : [],
                            amplifierComponents: amplifierComponent ? [amplifierComponent] : [],
                            buffersComponents: buffers,
                            chromogenComponents: chromogenComponent ? [chromogenComponent] : [],
                            priceModes: {
                                probeSetModes: probeSetPriceMode ? [probeSetPriceMode] : [],
                                amplifierModes: amplifierPriceMode ? [amplifierPriceMode] : [],
                                buffersModes: buffersPrices,
                                chromogenModes: chromogenPriceMode ? [chromogenPriceMode] : []
                            }
                        }
                    ],
                    comment: comment
                }
            };
        };
    }
    return ManualProAdminKitSerializer;
}());
export default ManualProAdminKitSerializer;
export var serializePriceModeWithIndex = function (index, m) {
    var constPriceMode = serializePriceMode(m);
    return {
        priceModeRequest: constPriceMode,
        index: index
    };
};
//# sourceMappingURL=ManualProAdminKitSerializer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/bundle-of-kits/ManualProAdminKitSerializer.js
// module id = 1094
// module chunks = 0